import { render, staticRenderFns } from "./AgentCorpMailManager.vue?vue&type=template&id=4d2aa6da&scoped=true&"
import script from "./AgentCorpMailManager.vue?vue&type=script&lang=js&"
export * from "./AgentCorpMailManager.vue?vue&type=script&lang=js&"
import style0 from "./AgentCorpMailManager.vue?vue&type=style&index=0&id=4d2aa6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2aa6da",
  null
  
)

export default component.exports